import { Component, Injector, OnInit } from '@angular/core';
import { BaseComponent } from '@app/shared/base/base-component/base-component.component';
import { JwtData } from '@app/shared/interfaces/jwt-data';
import { LoginService } from '@app/shared/services/Login.service';
import jwt_decode from 'jwt-decode';
import { tap } from 'rxjs';
@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.less'],
})
export class UserProfileComponent extends BaseComponent implements OnInit {
  userData: JwtData;
  constructor(private loginService: LoginService, injector: Injector) {
    super(injector);
  }

  ngOnInit() {
    const token = localStorage.getItem('token');
    const tokenData = new JwtData(jwt_decode(token!));
    this.userData = tokenData;
  }

  resetPasswordRequest() {
    this.subscriptions.push(
      this.loginService
        .sendResetPassRequest(this.userData.email)
        .pipe(
          tap(() => {
            this.message.success('Reset password Email has been sent');
          })
        )
        .subscribe()
    );
  }
}
